import * as sso from "../reducers/ssoReducer";
import * as session from "../reducers/sessionReducer";
import * as header from "../reducers/headerReducer";
import * as dashboard from "../reducers/dashboardReducer";
import * as error from "../reducers/errorReducer";
import * as domain from "../reducers/domainReducer";

export const trueInitialState = {
    dashboard: dashboard.dashboardInitialState,
    domain: domain.domainInitialState,
    error: error.errorInitialState,
    header: header.headerInitialState,
    session: session.sessionInitialState,
    sso: sso.ssoInitialState,
};


